import React, { useState , useEffect} from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { connect, useDispatch, useSelector} from 'react-redux';
import { useLocation} from 'react-router-dom';
import { Formik } from 'formik';

//import { useStore } from 'react-redux'
import {
  Box,
  Button,
  Container,
  Grid,
  CircularProgress,
  Link,
  TextField,
  Typography,
  makeStyles,  
} from '@material-ui/core';
import Page from 'src/components/Page';
import { alertActions, userActions } from '../../_actions';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));
const LoginView = ({ history}) => {
  const classes = useStyles();
  const navigate = useNavigate();

//Aqui el codigo
const [inputs, setInputs] = useState({
  username: '',
  password: ''
});
const [submitted, setSubmitted] = useState(
  {
    label: 'Aceptar',
    state: false
  }
);
const { username, password } = inputs;
const loggingIn = useSelector(state => state.authentication.loggingIn);
const dispatch = useDispatch();
const location = useLocation();
useEffect(() => { 
  dispatch(alertActions.clear());
  dispatch(userActions.logout());   
}, []); 
const error = useSelector(state => state.alert.type);
    return (
      <Page
        className={classes.root}
        title="Login"
      >     
        <Box
          display="flex"
          flexDirection="column"
          height="100%"
          justifyContent="center"
        >
          <Container maxWidth="sm">
             <Formik
              initialValues={{
                email: '',
                password: ''
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string().email('El email no es valido').max(255).required('Email es requerido'),
                password: Yup.string().max(255).required('Contraseña es requerida')
              })}
              async onSubmit={(values, actions) => {           
               setSubmitted({
              label: 'Cargando...',
              state: true
              });           
            if (values.email && values.password) {          
            const { from } = location.state || { from: { pathname: "/" } };           
              dispatch(userActions.login(values.email, values.password, from));
              setTimeout(function(){
                setSubmitted({
                  label: 'Aceptar',
                  state: false
                  });
                  //actions.resetForm({values :''});
            }, 700);
        }}}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                setSubmitted,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box mb={3}>
                    <Typography
                      color="textPrimary"
                      variant="h2"
                    >
                      Iniciar Sesión
                    </Typography>                
                  </Box>
                  <Grid
                    container
                    spacing={3}
                  >     
                
                  </Grid>                
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    label="Email"
                    margin="normal"
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="email"
                    value={values.email}
                    variant="outlined"
                  />
                  <TextField
                    error={Boolean(touched.password && errors.password)}
                    fullWidth
                    helperText={touched.password && errors.password}
                    label="Contraseña"
                    margin="normal"
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="password"
                    value={values.password}
                    variant="outlined"
                  />
                  <Box my={2}>
                    <Button
                      color="primary"
                      disabled={submitted.state}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                    >            
                    {submitted.label}                    
                    </Button>
                  </Box>
                  <Typography
                    color="textSecondary"
                    variant="body1"
                  >
                    ¿No tengo una cuenta?
                    {' '}
                    <Link
                      component={RouterLink}
                      to="/register"
                      variant="h6"
                    >
                      Registrarse 
                    </Link>
                    , 
                    <Link
                      component={RouterLink}
                      to="/forgot-password"
                      variant="h6"
                    >
                        ¿Olvidó su contraseña?
                    </Link>
                  </Typography>
                </form>
              )}
            </Formik>
          </Container>
        </Box>
      </Page>
    );
  };
 
  function mapState(state) {
    const { loggingIn } = state.authentication;
    return { loggingIn };
}

const actionCreators = {
    login: userActions.login,
    logout: userActions.logout
};
export default connect(mapState, actionCreators)(LoginView);